/**
 * @typedef {'prepend' | 'append' | 'before' | 'after' | 'html'} RenderOption
 */

/**
 * init component
 * @param {{
 *   target: jQuery | HTMLElement | string,
 *   renderOption: RenderOption,
 *   template: () => string
 * }} props
 */
const init = (props) => {
    render(props.target, props.renderOption, props.template)
}

/**
 * render component
 * @param {jQuery | HTMLElement | string} target
 * @param {RenderOption} option
 * @param {() => string} template
 */
const render = (target, option= 'html', template) => {
    const html = template()

    if (option === 'prepend') {
        target.prepend(html)
    }

    if (option === 'append') {
        target.append(html)
    }

    if (option === 'before') {
        target.before(html)
    }

    if (option === 'after') {
        target.after(html)
    }

    if (option === 'html') {
        target.html(html)
    }
}

export default {
    init,
}
